export const removeUndefinedKeysFromObject = (obj: Record<string, any>) => JSON.parse(JSON.stringify(obj))
